<template>
  <b-row
    id="deParaCompetencia"
    ref="deParaCompetencia"
    align-v="center"
    no-gutters
  >
    <b-col
      cols="6"
      class="pr-1"
    >
      <vue-monthly-picker
        v-model="valueInner.dataInicio"
        :input-class="'input-sm form-control w-100'"
        :date-format="'MM/YYYY'"
        :month-labels="['Jan', 'Fev', 'Mar','Abr','Maio','Jun','Jul','Ago','Set','Out','Nov','Dez']"
        :alignment="'left'"
      />
    </b-col>
    <b-col cols="6">
      <vue-monthly-picker
        v-model="valueInner.dataFim"
        :input-class="'input-sm form-control w-100' "
        :date-format="'MM/YYYY'"
        :month-labels="['Jan', 'Fev', 'Mar','Abr','Maio','Jun','Jul','Ago','Set','Out','Nov','Dez']"
        :alignment="'left'"
        :disabled="!valueInner.dataInicio"
      />
    </b-col>
  </b-row>
</template>

<style lang="scss">
#deParaCompetencia {
  .start-date input.form-control {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .end-date input.form-control {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }

  .display-text {
    height: 100%;
  }

  .vue-monthly-picker .month-picker-wrapper {
    min-width: 0px !important;
  }
}
</style>

<script>
/* eslint-disable func-names */

import Vue from 'vue'
import moment from 'moment'
import VueMonthlyPicker from 'vue-monthly-picker'

export default {
  name: 'DeParaCompetencia',
  components: {
    VueMonthlyPicker,
  },
  props: {
    requiredEnd: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
    },
  },
  data() {
    return {
      valueInner: {
        dataInicio: null,
        dataFim: null,
      },
      disabledDates: {},
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value, oldValue) {
        if (value !== oldValue) {
          this.valueInner = value
          Vue.set(this.valueInner, 'dataInicio', this.value.dataInicio)
          Vue.set(this.valueInner, 'dataFim', this.value.dataFim)
        }
      },
    },
    'valueInner.dataFim': function (value, oldValue) {
      if (value && !this.valueInner.dataFim) {
        this.invalidDataInicio = true
      } else {
        this.invalidDataInicio = false
      }

      if (value !== oldValue) {
        this.$emit('input', { dataInicio: this.valueInner.dataInicio, dataFim: value })
      }
    },
    'valueInner.dataInicio': function (value, oldValue) {
      const date = moment(value, 'MM/YYYY').toDate()
      Vue.set(this.disabledDates, 'to', date)
      if (!value && this.valueInner.dataFim) {
        this.valueInner.dataFim = null
      }

      if (value !== oldValue) {
        this.$emit('input', { dataInicio: value, dataFim: this.valueInner.dataFim })
      }
    },
  },
  focus() {
    this.$refs.dataInicio.$el.focus()
  },
}
</script>
